/**
 * Maps backend error codes to i18n keys so user-facing copy is translated
 * instead of showing raw backend strings.
 *
 * Two flavors of code live here, distinguished by their prefix:
 *   * **Envelope codes** ``APP.TYPE.ID`` (e.g. ``TEAM.VAL.035``) — emitted in
 *     the response envelope's ``error_code`` field for whole-request errors.
 *     Defined per-AppException subclass on the backend.
 *   * **Field-level codes** ``field.<kind>`` (e.g. ``field.unique``) —
 *     emitted inside ``details`` by serializers raising
 *     ``StructuredValidationError`` (see ``approveit/exceptions.py``). The FE
 *     renderer interpolates ``params`` (e.g. ``{resource, field}``) into the
 *     matched i18n string. Future kinds: ``field.required``,
 *     ``field.max_length``, ``field.format``, etc.
 *
 * If a code has no entry here, the renderer falls back to the server's
 * ``message`` field.
 */
export const ERROR_CODE_I18N_MAP: Record<string, string> = {
  'TEAM.VAL.035': 'common:invites.alreadyMember',
  'ACC.VAL.112': 'accounting:org.errors.integrationNotLinked',
  'field.unique': 'common:errors.uniqueField',
}
